import Health from './Health';

export default Health;
export type { Props } from './Health';
